/**
 * Форматирует целое число с разделителями разрядов в ru-RU локали.
 * @returns строка с пробелами-разделителями, напр. 7708 -> "7 708"
 */
export const formatCount = (count: number): string =>
  count.toLocaleString("ru-RU");
